import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import AddBoxIcon from "@mui/icons-material/AddBox";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PersonIcon from "@mui/icons-material/Person";

export default function WebBottomNavigation({ value, onChange }) {
  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        zIndex: 1100,
        overflow: "hidden",
      }}
      elevation={3}
    >
      <BottomNavigation showLabels value={value} onChange={onChange}>
        <BottomNavigationAction label="排盘" icon={<AddBoxIcon />} />
        <BottomNavigationAction label="记录" icon={<ListAltIcon />} />
        <BottomNavigationAction label="我的" icon={<PersonIcon />} />
      </BottomNavigation>
    </Paper>
  );
}
